import { render, staticRenderFns } from "./AppMenuItemsList.vue?vue&type=template&id=25506cfd&scoped=true"
import script from "./AppMenuItemsList.vue?vue&type=script&lang=js"
export * from "./AppMenuItemsList.vue?vue&type=script&lang=js"
import style0 from "./AppMenuItemsList.vue?vue&type=style&index=0&id=25506cfd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@1.19.1_vue-template-compiler@2.7.16_webpack@5.97.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25506cfd",
  null
  
)

export default component.exports